import React from "react";
import Chart from "react-apexcharts";
const areaColors = {
  series1: "#cb3de9",
  series2: "#0aefdf",
};
function VisitInsights(props) {
  const saleDateByMonth = props.saleDateByMonth;
  const sortedSalesDataByMonth = props.sortedSalesDataByMonth;

  const options = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: "Visit Insights",
      align: "left",
    },
    colors: [areaColors.series2, areaColors.series1],
    legend: {
      tooltipHoverFormatter: function (val, opts) {
        return (
          val +
          " - " +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          ""
        );
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: saleDateByMonth.map((item) => item),
    },
    tooltip: {
      y: [
        {
          title: {
            formatter: function (val) {
              // return val + " (mins)";
              return val;
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
        {
          title: {
            formatter: function (val) {
              return val;
            },
          },
        },
      ],
    },
    grid: {
      borderColor: "#404040",
    },
  };

  // ** Chart Series
  const series = [
    {
      name: "Sponsor Count",
      data: sortedSalesDataByMonth.map((item) => item.count),
    },
    {
      name: "Earnings",
      data: sortedSalesDataByMonth.map((item) => item.earnings),
    },
  ];
  return (
    <>
      <div className="bg-light-grey-cus">
        <Chart options={options} series={series} type="bar" height={400} />
      </div>
    </>
  );
}

export default VisitInsights;
